<template>
  <div class="h-screen overflow-y-hidden">
    <portal to="destination"> 
      <div v-show="removeModalOpen" class="flex justify-center items-center absolute z-20 bg-gray-500 bg-opacity-30 h-screen w-full">
        <ConfirmModal :postId="postInfo.id" :postDate="postDateDay" v-on:closeModal="closeConfirmModal"/>
      </div>
    </portal> 
    <!--Header-->
    <div class="w-full px-6 h-20 flex flex-wrap justify-between items-center border-b relative">
      <h4 class="text-yank ml-16 hidden sm:block">All Posts<span class="text-payneHot">({{ posts.data.length }})</span></h4>
      <h4 class="text-yank text-center sm:justify-center">Submission Info</h4>
      <button @click="confirmDelete" class="border-2 border-gray p-2 rounded-lg">
        <TrashIcon class="text-yank opacity-40"/>
      </button>
    </div>
    <!--Content-->
     <div class="flex flex-wrap">
         <!--LeftSide-->
         <div class="w-full lg:w-4/12 hidden sm:block">
            <div class="flex space-x-2 px-6 py-4">
                <SearchInput @search="addFilter('search', $event)" input-classes="bg-smoke h-10 items-center" class="mb-3 text-sm" />
                <button
                  :disabled="!isSearchActive"
                  @click="removeFilter"
                  class="transition duration-150 ease-in-out border border-transparent rounded-full px-6 bg-smoke flex-shrink-0 text-sm h-10 flex items-center mb-2 md:mb-0 hover:bg-payneMiddle hover:text-white"
                >
                  Clear
                </button>
            </div>
            
            <div class="mb-4 relative py-5 bg-platinum uppercase">
                <span class=" font-semibold ml-24 text-xs text-payneFire">title</span>
            </div>

            <div class="h-screen overflow-scroll pb-72">
              <DetailsPostRow v-for="post in allPosts" :date="post.post_date" :text="post.caption" :post="post" :postId="post.id" :key="post.id"/>
            

            <infinite-loading ref="infiniteLoader" @infinite="loadMore">
                <div slot="spinner">
                  <div class="items-grid ml-4 mt-8">
                    <item-skeleton />
                  </div>
                  <div class="items-grid ml-4 mt-8">
                    <item-skeleton />
                  </div>
                  <div class="items-grid ml-4 mt-8">
                    <item-skeleton />
                  </div>
                  <div class="items-grid ml-4 mt-8">
                    <item-skeleton />
                  </div>
                </div>
                <div slot="no-more" class="mt-8 text-sm font-medium text-payneFire">No more media to display</div>
                <div slot="no-results" class="mt-8 text-sm font-medium text-payneFire">No more media to display</div>
            </infinite-loading>
            </div>
        </div>
         <!--RightSide-->
         <div class="w-full lg:w-8/12 bg-platinumHot relative pb-10">
          <div class="relative">
             <PostPhotoDetails :instagramSelected="instagramSelected()" :facebookSelected="facebookSelected()" :postType="postInfo.type" :media="postInfo.media_url" positions="static" :created="postInfo.created_at" :postDate="postInfo.post_date"/>
             <inertia-link class="absolute flex justify-center items-center  p-0 w-10 h-10 rounded-full p bg-gray-200 opacity-50 hover:opacity-100 transition-all duration-500 text-payneFire drop-shadow-md top-5 left-5" :href="$route('scheduler.posts.index')">
               <XIcon/>
             </inertia-link>
          </div>
             <!--Info Menu-->
             <div class="flex items-center pt-6 bg-white h-16 pl-4 ">
                 <inertia-link :class="page == 'edit' || page == 'info' ? 'border-b-2 border-gray-200' : 'border-none text-payneFire'" class="w-2/12 h-full pl-2 font-semibold text-sm" :href="$route('scheduler.posts.show',[postInfo.id,'info'])">Info</inertia-link>
                 <inertia-link :class="page == 'media' ? 'border-b-2 border-gray-200' : 'border-none text-payneFire'" class="w-2/12 h-full pl-2 border-b-2 border-gray-200 font-semibold text-sm" :href="$route('scheduler.posts.show',[postInfo.id,'media'])">Media</inertia-link>
             </div>
            <!--details Content-->
            <div class="h-screen overflow-scroll pb-full">
              <MediaDetails :posted="postInfo.state === 'posted'" v-if="page == 'media'" :postType="postInfo.type" :media="postInfo.media_url"/>
              <SchedulerInfo :posted="postInfo.state === 'posted'" v-if="page == 'edit' || page == 'info'" :post="postInfo"/>
              <PostContent :posted="postInfo.state === 'posted'" @updatingPost="handleUpdatingPost()" @loadPosts="runSearch()" @captionChange="flashMessage('Pages updated correctly')" v-if="page == 'edit' || page == 'info'" :edit="page" :userPages="userPages" :post="postInfo"/>   
            </div>              
         </div>
     </div>
  </div>
</template>

<script>
import InfiniteLoading from 'vue-infinite-loading'

import AppLayout from '@/layout/app-layout';

import ItemSkeleton from "@/components/shared/ItemSkeleton"
import SearchInput from "@/components/shared/SearchInput";
import FiltersDropdown from "@/components/shared/Common/FiltersDropdown";

import TypeFilter from '@/components/filters/TypeFilter';
import CategoryFilter from '@/components/filters/CategoryFilter';

import MediaDetails from '@/components/scheduler/Show/Media';
import DetailsPostRow from '@/components/scheduler/Show/PostRow';
import PostPhotoDetails from '@/components/scheduler/Common/PostPhotoDetails';
import SchedulerInfo from '@/components/scheduler/Show/SchedulerInfo';
import PostContent from '@/components/scheduler/Show/PostContent';
import TablePaginator from '@/components/scheduler/Table/Paginator';
import ConfirmModal from '@/components/scheduler/Common/ConfirmModal';

import PlusIcon from "@/components/svg/PlusIcon";
import TrashIcon from '@/components/svg/TrashIcon';
import MediaLogo from '@/components/svg/MediaLogo';
import Arrow from '@/components/svg/Arrow';
import XIcon from '@/components/svg/XIcon';

import dayjs from 'dayjs';

var utc = require('dayjs/plugin/utc');
dayjs.extend(utc);

export default {
  name:"ShowPost",

  layout: AppLayout,

  components: {
    TrashIcon,
    MediaLogo,
    SearchInput,
    TypeFilter,
    FiltersDropdown,
    CategoryFilter,
    PlusIcon,
    DetailsPostRow,
    PostPhotoDetails,
    Arrow,
    MediaDetails,
    SchedulerInfo,
    PostContent,
    TablePaginator,
    ConfirmModal,
    ItemSkeleton,
    XIcon,
    InfiniteLoading
  },

  props: {
    page: {
      type: String,
      required: true
    },
    userPages: {
      type: Array,
      required: true
    },
    posts: {
      type: Object,
      required: true
    },
    flash: {
      type: Object,
      required: true
    },
    postInfo: {
      type: Object,
      required: true
    }
  },

  remember: ['allPosts'],
    
  data() {
    return {
      isUpdatingPost:false,
      activeFilters: this.filters || {},
      allPosts: this.posts.data,
      filters: {
        type: null,
      },
      removeModalOpen:false
    }
  },

  mounted() {
    if (!this.posts.next_page_url) {
      this.$refs.infiniteLoader.stateChanger.loaded()
      this.$refs.infiniteLoader.stateChanger.complete()
    }
  },

  methods: {
    removeFilter(type) {
      delete this.activeFilters[type];
      this.runSearch();
    },
    loadMore($state) {
      if (!this.posts.next_page_url) {
        return
      }

      this.$inertia.visit(this.posts.next_page_url, {
        preserveState: true,
        preserveScroll: true,
        only: ['posts'],
        onFinish: () => {
          $state.loaded()
          if (!this.posts.next_page_url) {
            $state.complete()
          }
        }
      });      
    },
    handleUpdatingPost(updating){
      this.isUpdatingPost = updating;
    },

    flashMessage(mesagge){
        this.flash.success = mesagge;
    },

    confirmDelete() {
      this.removeModalOpen = true;
    },

    closeConfirmModal(){
      this.removeModalOpen = false;
    },

    visitPage: function(pageUrl) {
      this.$inertia.visit(pageUrl, this.parsedFilters, {
      preserveState: true,
      preserveScroll: true,
      });
    },

    addFilter(type, value) {
      this.$set(this.activeFilters, type, value);
      this.runSearch();
    },
    runSearch() {
      let postId = this.postInfo.id
      this.$inertia.get(this.$route('scheduler.posts.show',[postId,'edit']), this.parsedFilters, {
        onStart: (visit) => this.working = true,
        onFinish: (visit) => this.working = false,
        preserveScroll: true,
      })
    },

    instagramSelected() {
      let filteredPages = this.postInfo.pages.filter(page => page.provider === 'instagram');
      return filteredPages.length > 0;
    },

    facebookSelected() {
      let filteredPages = this.postInfo.pages.filter(page => page.provider === 'facebook');
      return filteredPages.length  > 0;
    }
  },

  computed: {
    postDateDay: function(){
      return this.postInfo.post_date===null ? 'No post date defined' : dayjs(this.postInfo.post_date).format('MMM HH:MM');
    },
    isSearchActive() {
      const url = new URL(this.$inertia.page.url, window.location.origin);
      const params = new URLSearchParams(url.search);
      return params.has("filter[search]");
    },
    parsedFilters() {
      const filters = {};

      Object.keys(this.activeFilters).forEach(key => {
        if (this.activeFilters[key] === null) {
          delete this.activeFilters[key];
          return;
        }

        let keyName = `filter[${key}]`;
        filters[keyName] = this.activeFilters[key];
      });

      return filters;
    },
  },

  watch: {
    flash: {
      handler(flash) {
        if (flash.success && flash.success !== '') {
          this.$toast.success(flash.success);
        }
        if (flash.error && flash.error !== '') {
          this.$toast.error(flash.error);
        }
      },
      deep: true,
    },

    posts(posts) {
      if(!isUpdatingPost){
        this.allPosts.push(...posts.data);
      }
    }
  },
}
</script>